import React from "react";
import EmptyData from "go-core/components/EmptyData";
import { LoadingContainer } from "go-core/components/Loading";
import { OrganizationApi, OrganizationProductPerCategoryApi } from "../../../../../../../services/Api/types";
import OrganizationProductCategory from "../Products/OrganizationProductCategory";

interface Props {
	organization: OrganizationApi;
	products: OrganizationProductPerCategoryApi[];
	loading: boolean;
}

const ProductsTabPreview = ({ organization, products, loading }: Props) => {
	if (loading) return <LoadingContainer />;

	return (
		<div className="d-flex flex-column">
			{products && products.length > 0 ? (
				products.map((product) => (
					<React.Fragment key={product.id}>
						<OrganizationProductCategory organization={organization} productPerCategory={product} />
						<hr />
					</React.Fragment>
				))
			) : (
				<EmptyData />
			)}
		</div>
	);
};

export default ProductsTabPreview;
